export const SIGNALR_CONNECTED = "SIGNALR_CONNECTED";
export const SIGNALR_DISCONNECTED = "SIGNALR_DISCONNECTED";

export interface SignalRConnectedAction {
    type: typeof SIGNALR_CONNECTED;
}

export interface SignalRDisconnectedAction {
    type: typeof SIGNALR_DISCONNECTED;
}

export type SignalRActionTypes = SignalRConnectedAction | SignalRDisconnectedAction;
